module.exports = __webpack_public_path__ + "img/header-engagementRings100Carat.eaa7c95.webp";